module.exports = __webpack_public_path__ + "img/02-01_Being patient.4f3a34ab.svg";